// extracted by mini-css-extract-plugin
export default {"r_l":"_191bf78adf accbec127c","t":"c597cffed8"};